"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDate = void 0;
exports.addDate = (number, operator, date = Date.now()) => {
    switch (operator) {
        case 'days':
            return date + 1000 * 3600 * 24 * number;
        case 'seconds':
            return date + 1000 * number;
        case 'minutes':
            return date + 60 * 1000 * number;
    }
};
//# sourceMappingURL=timestampHelper.js.map